/**
 * Phase 1.7 — WelcomeBanner.
 *
 * Top-of-dashboard greeting strip. Pure presentation — caller passes name,
 * date string, and an optional action node. Used once per dashboard mount;
 * not intended for nested or multi-instance use.
 */

import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

export interface WelcomeBannerProps {
  name: string;
  subtitle?: string;
  actions?: ReactNode;
  className?: string;
}

export function WelcomeBanner({ name, subtitle, actions, className }: WelcomeBannerProps): JSX.Element {
  return (
    <div className={cn('flex flex-wrap items-end justify-between gap-3', className)}>
      <div>
        <h1 className="font-display text-3xl text-charcoal dark:text-charcoal-dark">
          Howdy, <span className="italic text-clay dark:text-clay-dark">{name}</span>
        </h1>
        {subtitle ? <p className="mt-1 text-sm text-muted-foreground">{subtitle}</p> : null}
      </div>
      {actions ? <div className="flex items-center gap-2">{actions}</div> : null}
    </div>
  );
}
